import { Collapse, Space, Typography } from "antd";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectedViews } from "../../constant/table";
import { GREEN, LIGHT_BLUE, NEW_BLUE } from "../../constant/colors";
import { DateRangeFilter } from "../filter/DateRangeFilter";
import { ALL_TIMES } from "../../constant/filters";
import { selectFilters, selectSelectedView } from "../../store/selector";
import ACTIONS from "../../store/action";

const { Text, Title } = Typography;
const { Panel } = Collapse;

export const PatientActionsFiltersPanel = ({ handleInputDate, resetDatesToDefault, filtersVisible }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dates } = useSelector(selectFilters);
  const selectedView = useSelector(selectSelectedView);

  const setFiltersInputs = (filterName, value) => dispatch(ACTIONS.setFiltersInputs(filterName, value));

  const { patientViewedDateRange } = dates;

  const isLoginFiltersActive = () => {
    const patientViewedValue = dates?.patientViewedDateRange?.value;
    return patientViewedValue !== ALL_TIMES;
  };

  return (
    selectedView === selectedViews.patientActions && (
      <Collapse ghost expandIconPosition="end" style={{ display: !filtersVisible ? "none" : undefined }}>
        <Panel
          header={
            <Title level={5} style={{ color: NEW_BLUE }}>
              {t("tableFilters.patient_activity")}
              {isLoginFiltersActive() && (
                <div
                  style={{
                    position: "absolute",
                    background: GREEN,
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    left: "247px",
                    top: "24px"
                  }}
                />
              )}
            </Title>
          }
        >
          <Space size={16} direction="vertical" style={{ width: "100%" }}>
            {/* Last Login Date */}
            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.last_login_date")}
              </Text>
              <DateRangeFilter
                id="filter_last_login_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("patientViewedDateRange", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "patientViewedDateRange", value)
                }
                allowClear={true}
                onClear={() => resetDatesToDefault("patientViewedDateRange", ALL_TIMES)}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="patientViewedDateFilters"
                timeRange={patientViewedDateRange}
              />
            </Space>
          </Space>
        </Panel>
      </Collapse>
    )
  );
};
